<template>
  <div class="app-wrapper">
    <div class="app">
      <!--
        <Navigation v-if="!navigationDisabled"/>
        -->
      <Navigation v-if="!navigationDisabled" />
      <router-view />
      <Footer v-if="!navigationDisabled" />
    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "app",
  components: {
    Navigation,
    Footer,
  },
  data() {
    return {
      navigationDisabled: false,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.$store.commit("updateUser", user);
      if (user) {
        this.$store.dispatch("getCurrentUser");
        console.log(this.$store.state.profileEmail);
      }
    });
    this.checkRoute();
    //console.log("User ID:", firebase.auth().currentUser.uid);
    console.log("User ID:", firebase.auth().currentUser);
  },
  mounted() {},
  methods: {
    checkRoute() {
      if (
        this.$route.name === "Login" ||
        this.$route.name === "Register" ||
        this.$route.name === "ForgotPassword"
      ) {
        this.navigationDisabled = true;
        return;
      }
      this.navigationDisabled = false;
    },
  },
  watch: {
    $route() {
      this.checkRoute();
      // To Scroll To the top when a new link is visted
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Quicksand", sans-serif;
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
}

.link {
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  color: black;
}

.link-light {
  color: #fff;
}

.arrow {
  margin-left: 8px;
  width: 12px;
  path {
    fill: #000;
  }
}

.arrow-light {
  path {
    fill: #fff;
  }
}

.card-view-wrap {
  position: relative;
  //padding: 80px 16px;
  padding: 20px 16px;
  background-color: #f1f1f1;

  @media (min-width: 500px) {
    //padding: 100px 16px;
    padding: 30px 16px;
  }

  .cards {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;

    @media (min-width: 500px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1200px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

button {
  width: 100px;
  height: 55px;
  border-radius: 30px;
  color: white;
  background-color: #000;
  transition: 0.25s;
  font-size: 16px;
  margin-top: 15px;

  &:hover {
    width: 110px;
    transition: 0.25s;
  }
}

.error {
  text-align: center;
  font-size: 12px;
  //color: red;
  color: rgb(255, 18, 18);
}
</style>
